module.exports = __webpack_public_path__ + "static/media/inclined_bench.74a82fb0.png";